import React, { PureComponent } from 'react';
import cn from 'classnames';
import styles from './List.scss';
import Infinity from 'react-infinite';
import { withRouter } from 'react-router-dom';

import { loadData, setScrollTop } from 'actions/objects';

import { compileQuery } from 'utils';

import iconUp from 'assets/images/icons/icon-up.svg';

import Item from './Item';
import { connect } from 'react-redux';
import { gaEvent, trackGA } from 'services/ga';

const HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED = 60;

@withRouter
class List extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isScrollTopBtnShown: false,
    };

    this.renderList = this.renderList.bind(this);
    this.elementInfiniteLoad = this.elementInfiniteLoad.bind(this);
    this.handleInfinityLoad = this.handleInfinityLoad.bind(this);
  }

  componentDidMount() {
    const { data, scrollTop } = this.props;
    if (data && scrollTop != null) {
      this.scrollContainer.scrollTop = scrollTop;
    }

    trackGA(
      gaEvent.pageShow({
        screenName: this.props.location.pathname,
      })
    );
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    if (this.scrollContainer) {
      dispatch(setScrollTop(this.scrollContainer.scrollTop));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isCottegesPage !== this.props.isCottegesPage && this.scrollContainer) {
      this.scrollContainer.scrollTop = 0;
    }
  }

  renderList(data) {
    const {
      request: { priceMin, priceMax, costMin, costMax, areaFrom, areaTo, view_type },
      isTypeFilterAction,
      currency,
      location,
      profile,
    } = this.props;
    const query = compileQuery({
      priceMin,
      priceMax,
      costMin,
      costMax,
      areaFrom,
      areaTo,
      view_type,
    });
    return data
      ? [this.props.children].concat(
          data.map((building, i) => (
            <Item
              url={`/building/${building.id}`}
              chessUrl={`/building/${building.id}/chess?${query}`}
              key={building.id}
              item={building}
              index={i + 1}
              isTypeFilterAction={isTypeFilterAction}
              currency={currency}
              location={location}
            />
          ))
        )
      : null;
  }

  renderWireframe() {
    return (
      <div className={styles.WireframeWrap}>
        <div className={styles.WireframeControls}>
          <div className={styles.WireframeControlsTitle} />
          <div className={styles.WireframeControlsSubtitle} />
        </div>
        {this.renderWireframeList()}
      </div>
    );
  }
  renderWireframeList() {
    return [{}, {}, {}, {}, {}, {}].map((o, i) => (
      <div className={styles.WireframeList} key={i}>
        <div className={styles.WireframeItem}>
          <div className={styles.WireframeImage} />
          <div className={styles.WireframeMain}>
            <div className={styles.WireframeInner}>
              <div className={styles.WireframeAddressBlock}>
                <div className={styles.WireframeTitle} />
                <div className={styles.WireframeWrapperAddress}>
                  <div className={styles.WireframeAddress} />
                </div>
              </div>
              <div className={styles.WireframeInfoBlock}>
                <div className={styles.WireframeBlock}>
                  <div className={styles.WireframeBlockItem} />
                </div>
                <div className={styles.WireframeBlock}>
                  <div className={styles.WireframeBlockItem} />
                  <div className={styles.WireframeBlockItem} />
                </div>
              </div>
            </div>
            <div className={styles.WireframeStatus}>
              <div className={styles.WireframeStatusTitle} />
            </div>
          </div>
          <div className={styles.WireframePrice}>
            <div className={styles.WireframeAppartments} />
            <div className={styles.WireframePriceBlock}>
              <div className={styles.WireframeStartPrice} />
              <div className={styles.WireframePricePerMeter} />
            </div>
            <div className={styles.WireframeArea} />
          </div>
        </div>
      </div>
    ));
  }

  elementInfiniteLoad() {
    return (
      <div className={styles.LoaderWrapper}>
        <div className={styles.Loader} />
      </div>
    );
  }

  handleInfinityLoad() {
    const {
      data,
      isFinished,
      location: { pathname },
    } = this.props;
    // Не инициируем загрузку данных когда их еще не передавали (первоначальная
    // загрузка инициирутеся в родителе), а так же, если достигнут конец списка.
    if (!data || isFinished) {
      return;
    }
    const { dispatch, request } = this.props;
    const region = this.props.cities
      .find((cities) => cities.id === this.props.cityId)
      .areas.map(({ id }) => id);

    dispatch(
      loadData(true, {
        ...request,
        offset: data.length,
        typeId: pathname.includes('cottages') ? 2 : 1,
        region: request.region || region,
      })
    );
  }

  scrollToTop = () => {
    this.scrollContainer.scrollTop = 0;
  };

  handleInfintityScroll = () => {
    const isShown = this.state.isScrollTopBtnShown;
    if (this.scrollContainer.scrollTop >= HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED && !isShown) {
      this.setState({ isScrollTopBtnShown: true });
    }
    if (this.scrollContainer.scrollTop < HEIGHT_AFTER_WHICH_SCROLL_BUTTON_DISPLAYED && isShown) {
      this.setState({ isScrollTopBtnShown: false });
    }
  };

  render() {
    const { className, data, isFinished, isInfiniteLoading, containerHeight } = this.props;
    return (
      <div className={cn(styles.Container, className)}>
        {data ? (
          <Infinity
            className={cn(styles.ListContainer, 'custom-scrollbar')}
            isInfiniteLoading={isInfiniteLoading}
            // loadingSpinnerDelegate={this.elementInfiniteLoad()}
            infiniteLoadBeginEdgeOffset={isFinished ? undefined : 800}
            onInfiniteLoad={this.handleInfinityLoad}
            elementHeight={192}
            preloadBatchSize={2400}
            preloadAdditionalHeight={2400}
            containerHeight={containerHeight}
            handleScroll={this.handleInfintityScroll}
            ref={(ref) => {
              this.scrollContainer = ref;
            }}
          >
            {this.renderList(data)}
          </Infinity>
        ) : (
          this.renderWireframe([{}, {}, {}, {}, {}, {}])
        )}
        {this.state.isScrollTopBtnShown && (
          <div className={styles.GoToTop} onClick={this.scrollToTop}>
            <img src={iconUp} alt="" />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cityId: state.profile.cityId,
  cities: state.building.cities,
  currency: state.profile.user_region.country_currency_symbol,
});

export default connect(mapStateToProps)(List);



// WEBPACK FOOTER //
// ./src/components/Buildings/List/List.js